module.exports = __webpack_public_path__ + "static/media/WBN_B2B_Manufacturers_Buyers_Distributors_Exporters_Importers_Egypt.355bbf3a.png";